import { render } from "./App.vue?vue&type=template&id=2601ecbc&ts=true&lang=pug"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2601ecbc&lang=scss"

import exportComponent from "/Users/alexander/dev/apps/clientcave/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__